/**
 * Quick View — Club de Camisetas
 * Intercepta cualquier click en un link de producto (/products/...) en toda la
 * tienda y abre un modal con la info de ese producto, sin navegar de página.
 * No requiere editar ninguna tarjeta de producto existente.
 */
(function () {
  "use strict";

  var modal = document.getElementById("qv-modal");
  if (!modal) return;

  var loadingEl = modal.querySelector("[data-qv-loading]");
  var bodyEl = modal.querySelector("[data-qv-body]");
  var galleryEl = modal.querySelector("[data-qv-gallery]");
  var titleEl = modal.querySelector("[data-qv-title]");
  var priceEl = modal.querySelector("[data-qv-price]");
  var optionsEl = modal.querySelector("[data-qv-options]");
  var descriptionEl = modal.querySelector("[data-qv-description]");
  var qtyInput = modal.querySelector("[data-qv-qty]");
  var addBtn = modal.querySelector("[data-qv-add]");
  var addLabel = modal.querySelector("[data-qv-add-label]");
  var messageEl = modal.querySelector("[data-qv-message]");

  var currentProduct = null;
  var selectedOptions = [];

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function" && window.theme_money_format) {
      return Shopify.formatMoney(cents, window.theme_money_format);
    }
    return "$" + (cents / 100).toFixed(2);
  }

  function openModal() {
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
  }

  function closeModal() {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
    resetModal();
  }

  function resetModal() {
    bodyEl.hidden = true;
    loadingEl.hidden = false;
    messageEl.hidden = true;
    messageEl.textContent = "";
    qtyInput.value = 1;
    currentProduct = null;
    selectedOptions = [];
  }

  function findVariant(product, options) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var match = true;
      for (var j = 0; j < options.length; j++) {
        if (v.options[j] !== options[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function renderGallery(product) {
    galleryEl.innerHTML = "";
    var images = product.images && product.images.length ? product.images : [product.featured_image];
    var main = document.createElement("img");
    main.src = images[0];
    main.alt = product.title;
    main.setAttribute("data-qv-main-image", "");
    galleryEl.appendChild(main);

    if (images.length > 1) {
      var thumbs = document.createElement("div");
      thumbs.className = "qv-modal__gallery-thumbs";
      images.forEach(function (src, idx) {
        var t = document.createElement("img");
        t.src = src;
        t.alt = product.title + " " + (idx + 1);
        if (idx === 0) t.classList.add("is-active");
        t.addEventListener("click", function () {
          main.src = src;
          thumbs.querySelectorAll("img").forEach(function (i) { i.classList.remove("is-active"); });
          t.classList.add("is-active");
        });
        thumbs.appendChild(t);
      });
      galleryEl.appendChild(thumbs);
    }
  }

  function renderPrice(variant) {
    priceEl.innerHTML = "";
    var sale = document.createElement("span");
    sale.className = "qv-price--sale";
    sale.textContent = formatMoney(variant.price);
    priceEl.appendChild(sale);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var compare = document.createElement("span");
      compare.className = "qv-price--compare";
      compare.textContent = formatMoney(variant.compare_at_price);
      priceEl.appendChild(compare);
    }
  }

  function renderOptions(product) {
    optionsEl.innerHTML = "";
    selectedOptions = product.variants[0].options.slice();

    product.options.forEach(function (optionName, optionIndex) {
      var optionLabelText = (optionName && typeof optionName === "object") ? (optionName.name || "") : optionName;
      var values = [];
      product.variants.forEach(function (v) {
        if (values.indexOf(v.options[optionIndex]) === -1) values.push(v.options[optionIndex]);
      });

      var wrap = document.createElement("div");
      wrap.className = "qv-option";

      var label = document.createElement("span");
      label.className = "qv-option__label";
      label.textContent = optionLabelText;
      wrap.appendChild(label);

      var valuesWrap = document.createElement("div");
      valuesWrap.className = "qv-option__values";

      values.forEach(function (value) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "qv-option__value";
        btn.textContent = value;
        if (selectedOptions[optionIndex] === value) btn.classList.add("is-selected");

        var testOptions = selectedOptions.slice();
        testOptions[optionIndex] = value;
        var wouldMatch = findVariant(product, testOptions);
        if (!wouldMatch) btn.disabled = true;

        btn.addEventListener("click", function () {
          selectedOptions[optionIndex] = value;
          valuesWrap.querySelectorAll(".qv-option__value").forEach(function (b) {
            b.classList.remove("is-selected");
          });
          btn.classList.add("is-selected");
          updateSelectedVariant(product);
        });

        valuesWrap.appendChild(btn);
      });

      wrap.appendChild(valuesWrap);
      optionsEl.appendChild(wrap);
    });
  }

  function updateSelectedVariant(product) {
    var variant = findVariant(product, selectedOptions);
    if (!variant) return;
    renderPrice(variant);
    addBtn.disabled = !variant.available;
    addLabel.textContent = variant.available ? "Agregar al carrito" : "Agotado";
    addBtn.setAttribute("data-variant-id", variant.id);
  }

  function renderProduct(product) {
    currentProduct = product;
    titleEl.textContent = product.title;
    renderGallery(product);
    renderOptions(product);
    updateSelectedVariant(product);
    descriptionEl.innerHTML = product.description || "";
    loadingEl.hidden = true;
    bodyEl.hidden = false;
  }

  function loadProduct(handle) {
    resetModal();
    openModal();
    fetch("/products/" + handle + ".js")
      .then(function (res) {
        if (!res.ok) throw new Error("No se pudo cargar el producto");
        return res.json();
      })
      .then(renderProduct)
      .catch(function () {
        loadingEl.hidden = true;
        bodyEl.hidden = false;
        titleEl.textContent = "No se pudo cargar el producto";
        messageEl.hidden = false;
        messageEl.setAttribute("data-state", "error");
        messageEl.textContent = "Intenta de nuevo o abre el producto directamente.";
      });
  }

  function addToCart() {
    var variantId = addBtn.getAttribute("data-variant-id");
    var quantity = parseInt(qtyInput.value, 10) || 1;
    if (!variantId) return;

    addBtn.disabled = true;
    messageEl.hidden = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || "Error"); });
        return res.json();
      })
      .then(function () {
        messageEl.hidden = false;
        messageEl.removeAttribute("data-state");
        messageEl.textContent = "✓ Agregado al carrito";
        addBtn.disabled = false;
        document.dispatchEvent(new CustomEvent("cart:updated"));
        document.dispatchEvent(new CustomEvent("cart:open-drawer"));
        setTimeout(closeModal, 350);
      })
      .catch(function (err) {
        messageEl.hidden = false;
        messageEl.setAttribute("data-state", "error");
        messageEl.textContent = err.message || "No se pudo agregar al carrito.";
        addBtn.disabled = false;
      });
  }

  function getHandleFromUrl(url) {
    var match = url.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  // Delegación global: cualquier <a> a /products/... en toda la tienda
  document.addEventListener("click", function (e) {
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; // respeta abrir en nueva pestaña

    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    if (link.hasAttribute("data-qv-disable")) return; // escape hatch por si algún link debe navegar normal

    var handle = getHandleFromUrl(link.getAttribute("href"));
    if (!handle) return;

    e.preventDefault();
    loadProduct(handle);
  });

  modal.querySelectorAll("[data-qv-close]").forEach(function (el) {
    el.addEventListener("click", closeModal);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.classList.contains("is-open")) closeModal();
  });

  addBtn.addEventListener("click", addToCart);

  modal.querySelector("[data-qv-qty-minus]").addEventListener("click", function () {
    qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
  });
  modal.querySelector("[data-qv-qty-plus]").addEventListener("click", function () {
    qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
  });
})();